import React from 'react'
import Icon from './Icon'

const InfoMiniBanners = ({ store }) => {
  const whichstore = store
  const newLookStores = [
    21,
    73,
    80,
    90,
    93,
    96,
    97,
    116,
    125,
    163,
    170,
    188,
    295,
    492,
    608,
  ]
  const storesNowOpen = [549]
  const newStores = [494, 683]
  const newStoreNowOpen = [506, 382, 422, 488, 466]
  const storeNowClosed = [181, 527, 493, 520]

  return (
    <>
      {newLookStores.includes(whichstore) ? (
        <section className="absolute right-0 flex items-end flex-1 -mt-2 -mr-2 -bottom-9 sm:left-auto sm:right-0 sm:bottom-auto">
          <div className="flex items-center justify-start p-2 rounded-md shadow-lg bg-primary">
            <h2 className="mr-2 text-sm font-semibold leading-none text-white md:text-base white">
              New Look Store
            </h2>
            <Icon icon="infonewstore" className="h-4 md:h-6 fill-white" />
          </div>
        </section>
      ) : storesNowOpen.includes(whichstore) ? (
        <section className="absolute right-0 flex items-end flex-1 -mt-2 -mr-2 -bottom-9 sm:left-auto sm:right-0 sm:bottom-auto">
          <div className="flex items-center justify-start p-2 rounded-md shadow-lg bg-primary">
            <h2 className="mr-2 text-sm font-semibold leading-none text-white md:text-base white">
              Store Now Open
            </h2>
            <Icon icon="infonewstore" className="h-4 md:h-6 fill-white" />
          </div>
        </section>
      ) : newStores.includes(whichstore) ? (
        <section className="absolute right-0 z-10 flex items-end flex-1 -mt-2 -mr-2 -bottom-9 sm:left-auto sm:right-0 sm:bottom-auto">
          <div className="flex items-center justify-start p-2 rounded-md shadow-lg bg-primary">
            <h2 className="mr-2 text-sm font-semibold leading-none text-white md:text-base white">
              New Store
            </h2>
            <Icon icon="infonewstore" className="h-4 md:h-6 fill-white" />
          </div>
        </section>
      ) : newStoreNowOpen.includes(whichstore) ? (
        <section className="absolute right-0 z-10 flex items-end flex-1 mr-0 -mt-2 -bottom-9 sm:left-auto sm:right-0 sm:bottom-auto">
          <div className="flex items-center justify-start p-2 rounded-md shadow-lg bg-primary">
            <h2 className="mr-2 text-sm font-semibold leading-none text-white md:text-base white">
              New Store Now Open
            </h2>
            <Icon icon="infonewstore" className="h-4 md:h-6 fill-white" />
          </div>
        </section>
      ) : storeNowClosed.includes(whichstore) ? (
        <section className="absolute right-0 z-10 flex items-end flex-1 mr-0 -mt-2 -bottom-9 sm:left-auto sm:right-0 sm:bottom-auto">
          <div className="flex items-center justify-start p-2 rounded-md shadow-lg bg-primary">
            <h2 className="mr-2 text-sm font-semibold leading-none text-white md:text-base white">
              Store Now Closed
            </h2>
            <Icon icon="infonewstore" className="h-4 md:h-6 fill-white" />
          </div>
        </section>
      ) : null}
    </>
  )
}

export default InfoMiniBanners
